




















































































































import { Vue, Prop, Component } from "vue-property-decorator";
import { Company as ICompany } from "@/api/models/company";
import { FileItem as IFileItem } from "@/api/models/file-item";
import MiniModal from "@/components/form/MiniModal.vue";

@Component({ components: { MiniModal } })
export default class FileManagerTableItem extends Vue {
  @Prop() file!: IFileItem;
  @Prop() active!: boolean;
  @Prop() companyInfo!: ICompany;
  modalToRemove: boolean = false;

  get screenWidth() {
    return window.innerWidth;
  }
  selectFile() {
    this.$emit("selectFile", this.file);
  }
  deleteFile() {
    this.$emit("deleteFile", this.file);
  }
  checkImage(file: IFileItem) {
    return file.mimeType.includes("image");
  }
  getFileSizeFormatter(bytes: number, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }
}
